import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BookRegular from './book-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BookRegular {...validProps} />;
}

SvgComponent.iconName = 'bookRegular';

export const BookRegularIcon = svgIconWrapper(SvgComponent);
